const countryList = [
  { "code": "AF", "name": "Afghanistan" },
  { "code": "AL", "name": "Albania" },
  { "code": "DZ", "name": "Algeria" },
  { "code": "AO", "name": "Angola" },
  { "code": "AR", "name": "Argentina" },
  { "code": "AM", "name": "Armenia" },
  { "code": "AU", "name": "Australia" },
  { "code": "AT", "name": "Austria" },
  { "code": "AZ", "name": "Azerbaijan" },
  { "code": "BS", "name": "Bahamas" },
  { "code": "BH", "name": "Bahrain" },
  { "code": "BD", "name": "Bangladesh" },
  { "code": "BY", "name": "Bielorussia" },
  { "code": "BE", "name": "Belgio" },
  { "code": "BZ", "name": "Belize" },
  { "code": "BJ", "name": "Benin" },
  { "code": "BM", "name": "Bermuda" },
  { "code": "BT", "name": "Bhutan" },
  { "code": "BO", "name": "Bolivia" },
  { "code": "BA", "name": "Bosnia-Erzegovina" },
  { "code": "BW", "name": "Botswana" },
  { "code": "BR", "name": "Brasile" },
  { "code": "BN", "name": "Brunei" },
  { "code": "BG", "name": "Bulgaria" },
  { "code": "BF", "name": "Burkina Faso" },
  { "code": "BI", "name": "Burundi" },
  { "code": "CV", "name": "Capo Verde" },
  { "code": "KH", "name": "Cambogia" },
  { "code": "CM", "name": "Camerun" },
  { "code": "CA", "name": "Canada" },
  { "code": "TD", "name": "Ciad" },
  { "code": "CL", "name": "Cile" },
  { "code": "CN", "name": "Cina" },
  { "code": "CO", "name": "Colombia" },
  { "code": "KM", "name": "Comore" },
  { "code": "CG", "name": "Repubblica Del Congo" },
  { "code": "KP", "name": "Corea Del Nord" },
  { "code": "KR", "name": "Corea Del Sud" },
  { "code": "CI", "name": "Costa Azzurra" },
  { "code": "CR", "name": "Costa Rica" },
  { "code": "HR", "name": "Croazia" },
  { "code": "CU", "name": "Cuba" },
  { "code": "CY", "name": "Cipro" },
  { "code": "CZ", "name": "Repubblica Ceca" },
  { "code": "DK", "name": "Danimarca" },
  { "code": "DJ", "name": "Gibuti" },
  { "code": "DM", "name": "Dominica" },
  { "code": "DO", "name": "Repubblica Dominicana" },
  { "code": "EC", "name": "Ecuador" },
  { "code": "EG", "name": "Egitto" },
  { "code": "SV", "name": "El Salvador" },
  { "code": "GQ", "name": "Guinea Equatoriale" },
  { "code": "ER", "name": "Eritrea" },
  { "code": "EE", "name": "Estonia" },
  { "code": "ET", "name": "Etiopia" },
  { "code": "FJ", "name": "Fiji" },
  { "code": "FI", "name": "Finlandia" },
  { "code": "FR", "name": "Francia" },
  { "code": "GA", "name": "Gabon" },
  { "code": "GM", "name": "Gambia" },
  { "code": "GE", "name": "Georgia" },
  { "code": "DE", "name": "Germania" },
  { "code": "GH", "name": "Ghana" },
  { "code": "GR", "name": "Grecia" },
  { "code": "GT", "name": "Guatemala" },
  { "code": "GN", "name": "Guinea" },
  { "code": "GW", "name": "Guinea-Bissau" },
  { "code": "GY", "name": "Guyana" },
  { "code": "HT", "name": "Haiti" },
  { "code": "HN", "name": "Honduras" },
  { "code": "HU", "name": "Ungheria" },
  { "code": "IS", "name": "Islanda" },
  { "code": "IN", "name": "India" },
  { "code": "ID", "name": "Indonesia" },
  { "code": "IR", "name": "Iran" },
  { "code": "IQ", "name": "Iraq" },
  { "code": "IE", "name": "Irlanda" },
  { "code": "IL", "name": "Israele" },
  { "code": "IT", "name": "Italia" },
  { "code": "JM", "name": "Giamaica" },
  { "code": "JP", "name": "Giappone" },
  { "code": "JO", "name": "Giordania" },
  { "code": "KZ", "name": "Kazakistan" },
  { "code": "KE", "name": "Kenya" },
  { "code": "KI", "name": "Kiribati" },
  { "code": "KW", "name": "Kuwait" },
  { "code": "KG", "name": "Kyrgyzstan" },
  { "code": "LA", "name": "Laos" },
  { "code": "LV", "name": "Lettonia" },
  { "code": "LB", "name": "Libano" },
  { "code": "LS", "name": "Lesotho" },
  { "code": "LR", "name": "Liberia" },
  { "code": "LY", "name": "Libia" },
  { "code": "LI", "name": "Liechtenstein" },
  { "code": "LT", "name": "Lituania" },
  { "code": "LU", "name": "Lussemburgo" },
  { "code": "MO", "name": "Macao" },
  { "code": "MK", "name": "Macedonia" },
  { "code": "MG", "name": "Madagascar" },
  { "code": "MW", "name": "Malawi" },
  { "code": "MY", "name": "Malesia" },
  { "code": "MV", "name": "Maldive" },
  { "code": "ML", "name": "Mali" },
  { "code": "MT", "name": "Malta" },
  { "code": "MH", "name": "Isole Marshall" },
  { "code": "MR", "name": "Mauritania" },
  { "code": "MU", "name": "Mauritius" },
  { "code": "MX", "name": "Messico" },
  { "code": "FM", "name": "Micronesia" },
  { "code": "MD", "name": "Moldavia" },
  { "code": "MC", "name": "Principato Di Monaco" },
  { "code": "MN", "name": "Mongolia" },
  { "code": "ME", "name": "Montenegro" },
  { "code": "MA", "name": "Marocco" },
  { "code": "MZ", "name": "Mozambico" },
  { "code": "MM", "name": "Myanmar" },
  { "code": "NA", "name": "Namibia" },
  { "code": "NR", "name": "Nauru" },
  { "code": "NP", "name": "Nepal" },
  { "code": "NL", "name": "Olanda" },
  { "code": "NZ", "name": "Nuova Zelanda" },
  { "code": "NI", "name": "Nicaragua" },
  { "code": "NE", "name": "Niger" },
  { "code": "NG", "name": "Nigeria" },
  { "code": "NO", "name": "Norvegia" },
  { "code": "OM", "name": "Oman" },
  { "code": "PK", "name": "Pakistan" },
  { "code": "PW", "name": "Palau" },
  { "code": "PS", "name": "Palestina" },
  { "code": "PA", "name": "Panama" },
  { "code": "PG", "name": "Papua E Nuova Guinea" },
  { "code": "PY", "name": "Paraguay" },
  { "code": "PE", "name": "Peru" },
  { "code": "PH", "name": "Filippine" },
  { "code": "PL", "name": "Polonia" },
  { "code": "PT", "name": "Portogallo" },
  { "code": "QA", "name": "Qatar" },
  { "code": "RO", "name": "Romania" },
  { "code": "RU", "name": "Russia Federazione" },
  { "code": "RW", "name": "Ruanda" },
  { "code": "VC", "name": "Saint Vincent E Grenadine" },
  { "code": "WS", "name": "Samoa" },
  { "code": "SM", "name": "San Marino" },
  { "code": "ST", "name": "Sao Tome E Principe" },
  { "code": "SA", "name": "Arabia Saudita" },
  { "code": "SN", "name": "Senegal" },
  { "code": "RS", "name": "Serbia" },
  { "code": "SC", "name": "Seychelles" },
  { "code": "SL", "name": "Sierra Leone" },
  { "code": "SG", "name": "Singapore" },
  { "code": "SK", "name": "Slovacchia" },
  { "code": "SI", "name": "Slovenia" },
  { "code": "SB", "name": "Isole Solomon" },
  { "code": "SO", "name": "Somalia" },
  { "code": "ZA", "name": "Sudafrica" },
  { "code": "ES", "name": "Spagna" },
  { "code": "LK", "name": "Sri Lanka" },
  { "code": "SD", "name": "Sudan" },
  { "code": "SR", "name": "Suriname" },
  { "code": "SZ", "name": "Swaziland" },
  { "code": "SE", "name": "Svezia" },
  { "code": "CH", "name": "Svizzera" },
  { "code": "SY", "name": "Siria" },
  { "code": "TW", "name": "Taiwan" },
  { "code": "TJ", "name": "Tajikistan" },
  { "code": "TZ", "name": "Tanzania" },
  { "code": "TH", "name": "Thailandia" },
  { "code": "TG", "name": "Repubblica Togolese" },
  { "code": "TO", "name": "Tonga" },
  { "code": "TT", "name": "Trinidad And Tobago" },
  { "code": "TN", "name": "Tunisia" },
  { "code": "TR", "name": "Turchia" },
  { "code": "TM", "name": "Turkmenistan" },
  { "code": "TV", "name": "Tuvalu" },
  { "code": "UG", "name": "Uganda" },
  { "code": "UA", "name": "Ucraina" },
  { "code": "AE", "name": "Emirati Arabi Uniti" },
  { "code": "GB", "name": "Regno Unito" },
  { "code": "US", "name": "Stati Uniti" },
  { "code": "UY", "name": "Uruguay" },
  { "code": "UZ", "name": "Uzbekistan" },
  { "code": "VU", "name": "Vanuatu" },
  { "code": "VE", "name": "Venezuela" },
  { "code": "VN", "name": "Vietnam" },
  { "code": "YE", "name": "Repubblica Dello Yemen" },
  { "code": "ZM", "name": "Zambia" },
  { "code": "ZW", "name": "Zimbabwe" }
];
